module.exports = __webpack_public_path__ + "img/zimbabwe.145433ed.svg";